import React, { ReactElement } from 'react';
import './statements.less';
import Layout from './Layout';
import AnnualStatements from './AnnualStatements';
import MonthlyStatements from './MonthlyStatements';
import AccountTypeEnum from '~Api/Investor/AccountTypeEnum';
import AnnualStatementAlert from '~Investor/AnnualStatementAlert';

export default function Statements(): ReactElement {
    return (
        <Layout section='statements'>
            <h1>Statements</h1>
            <AnnualStatementAlert accountType={AccountTypeEnum.Marketplace} />
            <div className='statements'>
                <AnnualStatements />
                <MonthlyStatements />
            </div>
        </Layout>
    );
}
